/* Cvetita Review Carousel - auto-init */
(function() {
  document.querySelectorAll('.cvetita-review-carousel').forEach(function(el) {
    var track = el.querySelector('.carousel-track');
    if (!track) return;
    var slides = track.querySelectorAll('.carousel-slide');
    if (slides.length < 2) return;

    var current = 0;
    var total = slides.length;

    /* Build nav arrows */
    var nav = document.createElement('div');
    nav.className = 'carousel-nav';
    nav.innerHTML = '<button class="carousel-btn carousel-prev" aria-label="Previous">&#8249;</button>'
      + '<button class="carousel-btn carousel-next" aria-label="Next">&#8250;</button>';
    el.appendChild(nav);

    /* Build dots */
    var dots = document.createElement('div');
    dots.className = 'carousel-dots';
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Slide ' + (i + 1));
      dot.dataset.index = i;
      dots.appendChild(dot);
    }
    el.appendChild(dots);

    function goTo(idx) {
      current = ((idx % total) + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      var allDots = dots.querySelectorAll('.carousel-dot');
      for (var j = 0; j < allDots.length; j++) {
        allDots[j].className = 'carousel-dot' + (j === current ? ' active' : '');
      }
    }

    nav.querySelector('.carousel-prev').addEventListener('click', function() { goTo(current - 1); });
    nav.querySelector('.carousel-next').addEventListener('click', function() { goTo(current + 1); });
    dots.addEventListener('click', function(e) {
      if (e.target.classList.contains('carousel-dot')) goTo(parseInt(e.target.dataset.index));
    });

    /* Touch/swipe support */
    var startX = 0, diffX = 0;
    track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, {passive: true});
    track.addEventListener('touchmove', function(e) { diffX = e.touches[0].clientX - startX; }, {passive: true});
    track.addEventListener('touchend', function() {
      if (Math.abs(diffX) > 40) goTo(current + (diffX < 0 ? 1 : -1));
      diffX = 0;
    });

    /* Auto-play every 6 seconds, pause on hover */
    var timer = setInterval(function() { goTo(current + 1); }, 6000);
    el.addEventListener('mouseenter', function() { clearInterval(timer); });
    el.addEventListener('mouseleave', function() { timer = setInterval(function() { goTo(current + 1); }, 6000); });
  });

  /* Cvetita Accordion FAQ - auto-init */
  document.querySelectorAll('.cvetita-accordion').forEach(function(accordion) {
    accordion.querySelectorAll('.accordion-item').forEach(function(item) {
      var header = item.querySelector('.accordion-header');
      var content = item.querySelector('.accordion-content');
      var icon = header.querySelector('span');
      if (!header || !content) return;

      header.addEventListener('click', function() {
        var isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';
        /* Close all others in this accordion */
        accordion.querySelectorAll('.accordion-content').forEach(function(c) {
          c.style.maxHeight = '0px';
          c.style.padding = '0 20px';
        });
        accordion.querySelectorAll('.accordion-header span').forEach(function(s) {
          s.textContent = '+';
          s.style.transform = 'rotate(0deg)';
        });
        /* Toggle current */
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + 32 + 'px';
          content.style.padding = '0 20px 16px 20px';
          if (icon) { icon.textContent = '-'; icon.style.transform = 'rotate(180deg)'; }
        }
      });
    });
  });
})();
